<template>
	<div id="radio-buttons">
		<div v-for="option in item.options" :key="option.id">
			<input
				v-model="radioValue"
				:type="item.inputType"
				:id="'option-' + option.id"
				:name="'option-' + item.id"
				:value="option.value"
				:required="item.required"
			/>
			<label :for="option.id" class="pis-2">{{ option.name }}</label>
		</div>
	</div>
</template>

<script>
export default {
	name: "RadioButtons",
	props: ["value", "item"],
	data() {
		return {
			radioValue: this.value,
		};
	},
	watch: {
		radioValue: function () {
			this.$emit("input", this.radioValue);
		},
	},
};
</script>

<style>
</style>